'use client';

import { useState, useEffect } from 'react';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressBar = ({ currentStep, totalSteps }: ProgressBarProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [animatedProgress, setAnimatedProgress] = useState(0);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (isHydrated) {
      const targetProgress = ((currentStep - 1) / (totalSteps - 1)) * 100;
      const timer = setTimeout(() => {
        setAnimatedProgress(targetProgress);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [currentStep, totalSteps, isHydrated]);

  if (!isHydrated) {
    return (
      <div data-component-id="src/app/process-timeline/components/ProgressBar.tsx:30:6" data-component-path="src/app/process-timeline/components/ProgressBar.tsx" data-component-line="30" data-component-end-line="32" data-component-file="ProgressBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20bg-surface%20rounded-full%20h-3%20overflow-hidden%22%7D" className="w-full bg-surface rounded-full h-3 overflow-hidden">
        <div data-component-id="src/app/process-timeline/components/ProgressBar.tsx:31:8" data-component-path="src/app/process-timeline/components/ProgressBar.tsx" data-component-line="31" data-component-end-line="31" data-component-file="ProgressBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-full%20bg-muted%20w-0%22%7D" className="h-full bg-muted w-0" />
      </div>
    );
  }

  return (
    <div data-component-id="src/app/process-timeline/components/ProgressBar.tsx:37:4" data-component-path="src/app/process-timeline/components/ProgressBar.tsx" data-component-line="37" data-component-end-line="44" data-component-file="ProgressBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20bg-surface%20rounded-full%20h-3%20overflow-hidden%20shadow-inner%22%7D" className="w-full bg-surface rounded-full h-3 overflow-hidden shadow-inner">
      <div data-component-id="src/app/process-timeline/components/ProgressBar.tsx:38:6" data-component-path="src/app/process-timeline/components/ProgressBar.tsx" data-component-line="38" data-component-end-line="43" data-component-file="ProgressBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-full%20bg-gradient-to-r%20from-primary%20via-primary-light%20to-primary%20rounded-full%20transition-all%20duration-1000%20ease-out%20relative%22%7D"
        className="h-full bg-gradient-to-r from-primary via-primary-light to-primary rounded-full transition-all duration-1000 ease-out relative"
        style={{ width: `${animatedProgress}%` }}
      >
        <div data-component-id="src/app/process-timeline/components/ProgressBar.tsx:42:8" data-component-path="src/app/process-timeline/components/ProgressBar.tsx" data-component-line="42" data-component-end-line="42" data-component-file="ProgressBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-white%20opacity-20%20animate-pulse%22%7D" className="absolute inset-0 bg-white opacity-20 animate-pulse" />
      </div>
    </div>
  );
};

export default ProgressBar;